import { RefObject } from "react";

import { ClassNameProps } from "@/types";

enum ProgressBarSize {
  Medium = "medium",
  Large = "large",
}

interface VideoProgressBarProps extends ClassNameProps {
  /* Size variant of the progress bar */
  size?: ProgressBarSize;

  /* Reference to the video element for live scrubbing */
  videoRef?: RefObject<HTMLVideoElement | null>;

  /* Callback when user seeks to a new time (final position) */
  onSeek: (time: number) => void;

  /* Callback when user is scrubbing (live preview) */
  onScrub?: (time: number) => void;

  /* Parent-controlled dragging state (optional - for coordinating multiple components) */
  isDraggingControlled?: boolean;

  /* Callback when dragging starts */
  onDragStart?: () => void;

  /* Callback when dragging ends */
  onDragEnd?: () => void;
}

export { ProgressBarSize };
export type { VideoProgressBarProps };
